import { Tooltip, Chip, TooltipProps, ChipOwnProps } from '@mui/material'
import { FC } from 'react'
import PendingIcon from '../../../../assets/images/pending-icon.svg?react'
import UpdatedIcon from '../../../../assets/images/engagement-details-icon.svg?react'

export interface StatusChipProps {
  ['data-testid']?: string

  status: 'pending' | 'updated'

  /**
   * By default, the label will be "Update Pending" for the "pending" status and "Updated" for the "updated" status,
   * but it can be overridden by passing a custom label.
   */
  label?: string

  /**
   * Each status has a default icon, but it can be overridden by passing a custom icon component.
   */
  icon?: ChipOwnProps['icon']

  /**
   * If provided, the chip will be wrapped in a tooltip with the given text.
   */
  tooltipText?: string
  tooltipPlacement?: TooltipProps['placement']
}

/**
 * https://mui.com/material-ui/react-chip/
 */
export const StatusChip: FC<StatusChipProps> = ({
  status,
  label = 'Update Pending',
  icon,
  tooltipPlacement,
  tooltipText,
  ['data-testid']: dataTestId
}) => {
  const chip = (
    <Chip
      label={label || (status === 'pending' ? 'Update Pending' : 'Updated')}
      icon={icon || (status === 'pending' ? <PendingIcon /> : <UpdatedIcon />)}
      // the default color state is gray which we are using for the "updated" status,
      // so that's why we are passing undefined.
      color={status === 'pending' ? 'warning' : undefined}
      data-testid={dataTestId}
    />
  )

  if (!tooltipText) return chip

  return (
    <Tooltip title={tooltipText} arrow placement={tooltipPlacement}>
      {chip}
    </Tooltip>
  )
}
